import { createPortal } from "react-dom";
import { Link } from "react-router-dom";

interface InsufficientCreditsDialogProps {
    onClose: () => void;
}

export const InsufficientCreditsDialog = ({ onClose }: InsufficientCreditsDialogProps) => {
    return createPortal(
        <div
            className="position-fixed top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
            style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 999999 }}
            onClick={onClose}
        >
            <div
                className="sengi-dialog p-4 text-body"
                style={{ maxWidth: 420 }}
                onClick={e => e.stopPropagation()}
            >
                <h5>Not enough credits</h5>
                <p className="text-secondary mb-4">
                    Your account balance isn't enough to run this action. Top up your credits to continue.
                </p>
                <div className="d-flex gap-2 justify-content-end">
                    <button type="button" className="btn btn-outline-secondary" onClick={onClose}>
                        Cancel
                    </button>
                    <Link to="/billing" className="btn btn-primary" onClick={onClose}>
                        Go to Billing
                    </Link>
                </div>
            </div>
        </div>,
        document.body
    );
};
